/**
 * Get shop domain from URL or Shopify App Bridge context
 */
export function getShopDomain(): string {
  // Try to get from URL parameter
  const urlParams = new URLSearchParams(window.location.search);
  const shopFromUrl = urlParams.get('shop');
  
  if (shopFromUrl) {
    return shopFromUrl;
  }
  
  // Try to get from App Bridge context if available
  if (typeof window !== 'undefined' && (window as any).shopify?.config) {
    return (window as any).shopify.config.shop || '';
  }
  
  // Fallback: try to extract from hostname
  const hostname = window.location.hostname;
  if (hostname.includes('.myshopify.com')) {
    return hostname;
  }
  
  // For development, return a default shop
  return 'vlad-stickycards-dev-store.myshopify.com';
}

